import { JSX, use, useState, useMemo, Suspense } from 'react'

import { Box } from '@chakra-ui/react'


import { HttpBody } from '@/lib/request.js'

import * as detective from '@/lib/detective.js'

import * as contract_storage from '@/storage/contract.js'

import * as toast from '@/components/ui/toast.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loading from '@/components/ui/loading.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Empty from '@/components/ui/empty.tsx'


// eslint-disable-next-line @typescript-eslint/naming-convention
import Signing from './components/signing.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Insurance from './components/insurance.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Protocol from './components/protocol.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Annex from './components/annex.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Agreement from './components/agreement.tsx'





// eslint-disable-next-line @typescript-eslint/naming-convention
export function Update
(
	props: {
		refresh(): void

		doc: Promise<null | HttpBody<contract_storage.TRawDocumentType> >


	},

)
:	JSX.Element
{
	let doc = use(props.doc)

	if (detective.is_empty(doc) )
	{
		return (
			<Empty.Miss h="48vh" title="尚未签约" description="该名员工没有正在执行的合同" />

		)

	}

	let on_refresh = (): void =>
	{
		props.refresh()

	}

	let on_update = (name: string, value: unknown): void =>
	{
		contract_storage.update(doc._id, { [name]: value })
			.catch(
				(e: unknown) =>
				{
					toast.error(e as Error)

				},

			)


	}

	return (
		<Box p="6" pb="32">
			<Signing doc={doc} update={on_update} />

			<Insurance doc={doc} update={on_update} />

			<Protocol doc={doc} update={on_update} />

			<Annex doc={doc} update={on_update} />

			<Agreement doc={doc} refresh={on_refresh} update={on_update} />

		</Box>

	)

}


export default function
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	let [refresh, update_refresh] = useState(0)

	let doc = useMemo(
		() => contract_storage.retrieve(props._id)
			.catch(
				() => null,

			),

		[props._id, refresh],

	)

	let on_refresh = (): void =>
	{
		update_refresh(v => v + 1)

	}

	return (
		<Suspense fallback={<Loading.Default h="48vh" />}>
			<Update doc={doc} refresh={on_refresh} />

		</Suspense>


	)

}
